/* ====================================================== */
/* ====================================================== */
/* ======= KLEVU TEMPLATE JS CUSTOMIZATION CODE ========= */
/* ============== QUICK SEARCH JAVASCRIPT =============== */
/* ======================== Moss ======================== */
/* ====================================================== */
/* ====================================================== */

var klevu_layoutType = "basic";
var klevu_layoutView = "grid";

klevu({
    analytics: {
        apiKey: "klevu-173988322575617908"
    }
});

klevu({
    theme: {
        setHelpers: {
            all: {
                setKlevuQuickPopupTopPositionVariable: function () {
                    klevu.each(
                        klevu.dom.find(".klevuWrap"),
                        function (key, currentElement) {
                            const topPosition = currentElement.getBoundingClientRect().top;
                            document.documentElement.style.setProperty(
                                "--klevuQuickPopupTopPosition",
                                `${topPosition}px`
                            );
                        }
                    );
                }
            },
        },
    },
});

klevu.beforeActivation("quick", function (data, scope) {
    klevu.each(klevu.search.extraSearchBox, function (key, box) {
        box.getScope().template.setTemplate(klevuQuickTemplateTabResultsCustom, "klevuQuickTemplateTabResults", true);
        box.getScope().template.setTemplate(klevuQuickTemplateFiltersCustom, 'klevuQuickTemplateFilters', true);
    });
});

klevu.modifyRequest("quick", function (data, scope) {
    klevu.each(data.request.current.recordQueries, function (key, query) {
        // No results limit
        const queryID = klevu.getObjectPath(query, "id");
        if (queryID === 'noResultsFoundPopularProductList') {
            klevu.setObjectPath(query, "settings.limit", 8);
        }
        // No results limit END
    });
});

klevu.afterTemplateRender("quick", function (data, scope) {
    scope.kScope.template.getHelpers().setKlevuQuickPopupTopPositionVariable();
    window.addEventListener("resize", scope.kScope.template.getHelpers().setKlevuQuickPopupTopPositionVariable());
});

(function (klevu) {
    klevu.extend({
        productCarousel: {
            base: {
                initProductsSlider: function (kuCarousel) {
                    return; // we don't need carousel
                }
            }
        }
    });
})(klevu);
/* ============== QUICK SEARCH TEMPLATES =============== */
const klevuQuickTemplateTabResultsCustom = `
    <% 
        var isCmsEnabled = klevu.search.modules.kmcInputs.base.getCmsEnabledValue(); 
        var hasAnyResultFound = false;
        helper.each(data.query,function(key,query) {
            if(query.tab == true) {
                if(helper.hasResults(data,query.id)) {
                    var results = data.query[query.id].meta.totalResultsFound;
                    if(results > 0){
                        hasAnyResultFound = true;
                    }
                }
            }
        });
    %>
    <div class="kuContainer">

        <% const totalResultsFound = Object.values(data.query).find(obj => obj && obj.id === "productList").meta.totalResultsFound %>
        <% if (totalResultsFound > 0 && !isCmsEnabled) { %>
            <div class="header-kuContainer-title">
                <span><%= helper.translate("Showing") %></span>
                <span><%= totalResultsFound %></span>
                <span><%= helper.translate("products") %></span>
            </div>
        <% } %>
    
        <div class="kuTabs" role="tablist" style="display:<%= isCmsEnabled && hasAnyResultFound ? 'block' : 'none'  %>">
            <% var selectedTab = false; %>
            <% helper.each(data.query,function(key,query){ %>
                <% if(query.tab == true) { %>
                    <% if(helper.hasResults(data,query.id)) { %>
                        <a target="_self" class="kuTab<% if(!selectedTab){ selectedTab = true; %> kuTabSelected<% } %>" data-section="<%=query.id%>" role="tab" tabindex="0" aria-selected="" area-label="Products tab">
                            <%=helper.translate(query.tabText,data.query[query.id].meta.totalResultsFound)%>
                        </a>
                    <% } else { %>
                        <a target="_self" class="kuTabDeactive" data-section="<%=query.id%>" role="tab" tabindex="0" aria-selected="" area-label="Products tab">
                            <%=helper.translate(query.tabText,0)%>
                        </a>
                    <% } %>
                <% } %>
            <% }); %>
        </div>
    </div>
`;

const klevuQuickTemplateFiltersCustom = 
    `<% if(data.query[dataLocal].filters.length > 0 ) { %>
        <div class="kuFilters" role="navigation" data-position="left" aria-label="Product Filters" tabindex="0">
            <% helper.each(data.query[dataLocal].filters,function(key,filter){ %>
                <% if(filter.type == "OPTIONS"){ %>
                    <div class="kuFilterBox klevuFilter <%=(filter.multiselect)?'kuMulticheck':''%>" data-filter="<%=filter.key%>" <% if(filter.multiselect){ %> data-singleselect="false" <% } else { %> data-singleselect="true"<% } %>>
                        <div class="kuFilterHead <%=(filter.isCollapsed) ? 'kuExpand' : 'kuCollapse'%>">
                            <% var filter_label = (filter.label=="klevu_price") ? "price" : filter.label; %>
                            <%=helper.translate(filter_label)%>
                        </div>
                        <div data-optionCount="<%= filter.options.length %>" class="kuFilterNames <%= (filter.options.length <= 5 ) ? 'kuFilterShowAll': '' %> <%=(filter.isCollapsed) ? 'kuFilterCollapse' : ''%>">
                            <ul>
                                <% helper.each(filter.options,function(key,filterOption){ %>
                                    <li <% if(filterOption.selected ==true) { %> class="kuSelected"<% } %>>
                                        <a 
                                            target="_self" 
                                            href="#" 
                                            title="<%=helper.escapeHTML(filterOption.name)%>" 
                                            class="klevuFilterOption<% if(filterOption.selected ==true) { %> klevuFilterOptionActive<% } %>" 
                                            data-value="<%=helper.escapeHTML(filterOption.value)%>"
                                            data-name="<%=helper.escapeHTML(filterOption.name)%>"
                                        >
                                            <span class="kuFilterIcon"></span>
                                            <span class="kufacet-text"><%=filterOption.name%></span>
                                            <% if(filterOption.selected ==true) { %>
                                                <span class="kuFilterCancel">X</span>
                                            <% } else { %>
                                                <span class="kuFilterTotal"><%=filterOption.count%></span>
                                            <% } %>
                                        </a>
                                    </li>
                                    
                                <%  }); %>
                            </ul>
                            <% if(filter.options.length > 5 ) { %>
                                <div class="kuShowOpt" tabindex="-1">
                                    <button class="ku-showMore" data-class="showMore">+ <%=helper.translate("Show")%> (<%= filter.options.length - 5 %>) <%=helper.translate("more")%> </button>
                                    <button class="ku-showMore" data-class="showLess">- <%=helper.translate("Show Less")%> </button>
                                </div>
                            <% } %>
                        </div>
                    </div>
                <% } else if(filter.type == "SLIDER")  { %>
                	<div class="kuFilterBox klevuFilter" data-filter="<%=filter.key%>">
                        <div class="kuFilterHead <%=(filter.isCollapsed) ? 'kuExpand' : 'kuCollapse'%>">
                        	<% var filter_label = (filter.label=="klevu_price") ? "price" : filter.label; %>
                            <%=helper.translate(filter_label)%>
                        </div>
                        <div class="kuFilterNames sliderFilterNames <%=(filter.isCollapsed) ? 'kuFilterCollapse' : ''%>">                           
  							<div class="kuPriceSlider klevuSliderFilter" data-query = "<%=dataLocal%>">
  								<div data-querykey = "<%=dataLocal%>" class="noUi-target noUi-ltr noUi-horizontal noUi-background kuSliderFilter kuPriceRangeSliderFilter<%=dataLocal%>"></div>
  							</div>
                        </div>
                    </div>
                <% } else if (filter.type == "RATING")  { %>
                    <div class="kuFilterBox klevuFilter <%=(filter.multiselect)?'kuMulticheck':''%>" data-filter="<%=filter.key%>" <% if(filter.multiselect){ %> data-singleselect="false" <% } else { %> data-singleselect="true"<% } %>>
                        <div class="kuFilterHead <%=(filter.isCollapsed) ? 'kuExpand' : 'kuCollapse'%>">
                            <%=helper.translate(filter.label)%>
                        </div>
                        <div data-optionCount="<%= filter.options.length %>" class="kuFilterNames <%= (filter.options.length <= 5 ) ? 'kuFilterShowAll': '' %> <%=(filter.isCollapsed) ? 'kuFilterCollapse' : ''%>">
                            <ul>
                                <% helper.each(filter.options,function(key,filterOption){ %>
                                    <li <% if(filterOption.selected ==true) { %> class="kuSelected"<% } %>>
                                        <a 
                                            target="_self" 
                                            href="#" 
                                            title="<%=helper.escapeHTML(filterOption.name)%>" 
                                            class="klevuFilterOption<% if(filterOption.selected ==true) { %> klevuFilterOptionActive<% } %>" 
                                            data-value="<%=helper.escapeHTML(filterOption.value)%>"
                                            data-name="<%=helper.escapeHTML(filterOption.name)%>"
                                        >
                                            <span class="kuFilterIcon"></span>
                                            <span class="kufacet-text">
                                                <div class="klevuFacetStars">
                                                    <div class="klevuFacetRating" style="width:<%=(20*Number(filterOption.name))%>%;"></div>
                                                </div>
                                            </span>
                                            <% if(filterOption.selected ==true) { %>
                                                <span class="kuFilterCancel">X</span>
                                            <% } else { %>
                                                <span class="kuFilterTotal"><%=filterOption.count%></span>
                                            <% } %>
                                        </a>
                                    </li>
                                    
                                <%  }); %>
                            </ul>
                        </div>
                    </div>
                <% } else { %>
                    <!-- Other Facets -->
                <% } %>
            <% }); %>
            
            <!-- <div class="kuFiltersFooter">
            	<a target="_self" href="javascript:void(0)" class="kuBtn kuFacetsSlideOut kuMobileFilterCloseBtn" role="button" tabindex="0" area-label=""><%=helper.translate("Close")%></a>
  			</div> -->
            
            
        </div>
    <% } %>
`;

/* ====================================================== */
/* ====================================================== */
/* ======= KLEVU TEMPLATE JS CUSTOMIZATION CODE ========= */
/* ============ LANDING & CATNAV JAVASCRIPT ============= */
/* ======================= Ripple ======================= */
/* ====================================================== */
/* ====================================================== */

// Create the useroptions object if it does not already exist
if (!window.klevu_uc_userOptions) window.klevu_uc_userOptions = {};

// set the landingFilterPosition
window.klevu_uc_userOptions.landingFilterPosition = 'left';

klevu({
    theme: {
        setHelpers: {
            "landing": {
                isScreenWidthSmaller: function (screenWidth) {
                    // use in JS: scope.kScope.template.getHelpers().isScreenWidthSmaller()
                    // use in templates: <% helper.isScreenWidthSmaller() %>
                    if (!screenWidth) screenWidth = 1024;
                    var widthOfScreen = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
                    return widthOfScreen <= screenWidth;
                }
            }
        }
    }
});

klevu.beforeActivation("landing", function (data, scope) {

    scope.kScope.template.setTemplate(klevuLandingTemplateResultsCustom, 'results', true);
    scope.kScope.template.setTemplate(klevuLandingTemplatePaginationCustom, 'pagination', true);
    scope.kScope.template.setTemplate(klevuLandingTemplateFiltersCustom, 'filters', true);
    scope.kScope.template.setTemplate(klevuLandingTemplateSortByCustom, 'sortBy', true);

    // Remove scrollToTop
    scope.kScope.chains.events.keyUp.remove({
        name: "scrollToTop"
    });
    
    (function (klevu) {
        klevu.extend(true, klevu.search.modules, {
            addParamsToURL: {
                base: {
                    addURLtoHistory: function (data, scope, queryId) {
                        // Global stuff
                        if (typeof window.history === "undefined" || typeof window.history.pushState === "undefined") {
                            console.error("This browser does not have the support of window.history or window.history.pushState");
                            return;
                        }

                        var searchPath = new URLSearchParams(window.location.search);
                        var currentSearchPath;
                        var previousSearchPath = searchPath.toString();

                        // this is in case we're running our code where we dont have context.activeQueryId
                        var activeQueryId = klevu.getObjectPath(data, "context.activeQueryId");
                        if (queryId && queryId.length) {
                            activeQueryId = queryId;
                        }

                        // Check if there any filter selected
                        let applyFilters = typeof data.localOverrides.query[activeQueryId].filters !== 'undefined' ? data.localOverrides.query[activeQueryId].filters.applyFilters : {};
                        let isThereFiltersSelected = false;
                        // Check if applyFilters is an object (but not an array), and not empty
                        if (typeof applyFilters === 'object' && !Array.isArray(applyFilters) && applyFilters !== null && Object.keys(applyFilters).length > 0) {
                            isThereFiltersSelected = true;
                        }

                        // PAGINATION TO URL
                        var hasPaginationEnabled = klevu.getSetting(klevu, "settings.theme.modules.pagination.searchResultsPage.enable");
                        var paginationQueryParam = "Page";
                        var currentPage = 0;

                        if (hasPaginationEnabled) {
                            var activeQueryMeta = klevu.getObjectPath(data, "template.query." + activeQueryId + ".meta");
                            if (activeQueryMeta) {
                                var productListLimit = activeQueryMeta.noOfResults;
                                currentPage = Math.ceil(activeQueryMeta.offset / productListLimit) + 1;
                            }

                            if (currentPage === 0 || currentPage === 1) {
                                searchPath.delete(paginationQueryParam);
                            } else {
                                searchPath.set(paginationQueryParam, currentPage);
                            }

                            currentSearchPath = searchPath.toString();
                        };

                        // FILTERS TO URL
                        var activeQueryFilters = klevu.getObjectPath(data, "template.query." + activeQueryId + ".filters");
                        var filterValuesQueryParam = "";

                        if (activeQueryFilters) {
                            klevu.each(activeQueryFilters, function (key, filter) {
                                var selectedFilterKeyString = "";
                                var filterOptions = filter.options;
                                var selectedValues = "";

                                if (filterOptions && filterOptions.length) {
                                    klevu.each(filterOptions, function (key, option) {
                                        if (option.selected === true) {
                                            if (selectedValues.length) {
                                                selectedValues += ",";
                                            }
                                            selectedValues += option.value;
                                        }
                                    });
                                } else if (filter.type === "SLIDER") {
                                    var startValue = filter.start;
                                    var endValue = filter.end;
                                    var minValue = filter.min;
                                    var maxValue = filter.max;
                                    if (typeof startValue !== "undefined" && startValue !== null && typeof endValue !== "undefined" && endValue !== null) {
                                        if (Number(startValue) === Number(minValue) && Number(endValue) === Number(maxValue)) {
                                            // just skipping
                                        } else {
                                            selectedValues = startValue + "-" + endValue;
                                        }
                                    }
                                }

                                if (selectedValues.length) {
                                    // selectedFilterKeyString += filter.key + ":" + selectedValues;
                                    selectedFilterKeyString += encodeURIComponent(filter.key) + ":" + encodeURIComponent(selectedValues);
                                }

                                if (selectedFilterKeyString.length) {
                                    if (filterValuesQueryParam.length) {
                                        filterValuesQueryParam += ";";
                                    }
                                    filterValuesQueryParam += selectedFilterKeyString;
                                }
                            });
                        }

                        if (filterValuesQueryParam.length > 0 && isThereFiltersSelected) {
                            searchPath.set("Filters", filterValuesQueryParam);
                        } else {
                            searchPath.delete("Filters");
                        }

                        currentSearchPath = searchPath.toString();

                        // ==============================
                        // Final URL change
                        if (previousSearchPath !== currentSearchPath) {
                            var historyState = { page: currentPage, filters: currentSearchPath };
                            window.history.pushState(historyState, null, currentSearchPath ? '?' + currentSearchPath : window.location.pathname);
                        }
                    },

                    restoreSearchParamsOnPageLoad: function (data, scope) {
                        var hasAlreadyTriggered = klevu.getObjectPath(scope.kScope, "element.kScope.getAndUpdateFiltersTriggered");
                        if (hasAlreadyTriggered) return;

                        var activeQueryId = klevu.getObjectPath(data, "context.activeQueryId") || "productList";

                        var filtersFromURL = klevu.dom.helpers.getQueryStringValue("Filters");
                        var paginationFromURL = klevu.dom.helpers.getQueryStringValue("Page");

                        var matchedQueryParamId = "";
                        var matchedQueryParamValue = "";
                        var recordQueries = klevu.getObjectPath(data, "request.current.recordQueries");

                        if (recordQueries && recordQueries.length) {
                            klevu.each(recordQueries, function (key, recordQuery) {
                                if (recordQuery.id) {
                                    if ((paginationFromURL && paginationFromURL.length) || (filtersFromURL && filtersFromURL.length)) {
                                        matchedQueryParamId = recordQuery.id;
                                        matchedQueryParamValue = paginationFromURL || filtersFromURL;
                                    }
                                }
                            });
                        }

                        klevu.setObjectPath(scope.kScope, "element.kScope.getAndUpdateFiltersTriggered", true);

                        matchedQueryParamId = activeQueryId || "productList";

                        if (matchedQueryParamId.length && matchedQueryParamValue.length) {
                            activeQueryId = matchedQueryParamId;
                            var storage = klevu.getSetting(scope.kScope.settings, "settings.storage");
                            if (storage.tabs) {
                                storage.tabs.setStorage("local");
                                storage.tabs.mergeFromGlobal();
                                storage.tabs.addElement("active", activeQueryId);
                                storage.tabs.mergeToGlobal();
                            }
                        }

                        if (paginationFromURL && paginationFromURL > 1) {
                            if (recordQueries && recordQueries.length) {
                                klevu.each(recordQueries, function (key, recordQuery) {
                                    if (recordQuery.id === activeQueryId) {
                                        var limit = klevu.getObjectPath(recordQuery, "settings.limit");
                                        limit = Number(limit);
                                        if (limit > 0) {
                                            var expectedOffset = (paginationFromURL - 1) * limit;
                                            klevu.setObjectPath(data, "localOverrides.query." + activeQueryId + ".settings.offset", expectedOffset);
                                        }
                                    }
                                });
                            }
                        }

                        // FILTERS
                        if (filtersFromURL && filtersFromURL.length) {
                            var facets = filtersFromURL.split(";");
                            if (facets) {
                                klevu.each(facets, function (key, facet) {
                                    var splitFacet = facet.split(":");
                                    if (splitFacet.length) {
                                        var facetKey = decodeURIComponent(splitFacet[0]);
                                        var facetValues = decodeURIComponent(splitFacet[1]).split(",");
                                        var applyFilters = klevu.getObjectPath(data, "localOverrides.query." + activeQueryId + ".filters.applyFilters.filters");

                                        if (applyFilters && applyFilters.length) { // if there're some filters
                                            var isExistingKey = false;
                                            klevu.each(applyFilters, function (key, applyFilter) {
                                                if (applyFilter.key === facetKey) {
                                                    isExistingKey = true;
                                                    klevu.each(facetValues, function (key, facetValue) {
                                                        var isFilterOptionMatched = false;
                                                        klevu.each(applyFilter.values, function (key, value) {
                                                            if (facetValue === value) {
                                                                isFilterOptionMatched = true;
                                                            }
                                                        });
                                                        if (!isFilterOptionMatched) {
                                                            applyFilter.values.push(facetValue);
                                                        }
                                                    });
                                                }
                                            });
                                            if (!isExistingKey) {
                                                applyFilters.push({ key: facetKey, values: facetValues });
                                            }
                                        } else {
                                            klevu.setObjectPath(data, "localOverrides.query." + activeQueryId + ".filters.applyFilters.filters", [{ key: facetKey, values: facetValues }]);
                                        }

                                    }
                                });
                            }
                        }
                    },

                    updatePayloadOnPopState: function (data, scope, activeQueryId) {
                        // SET PAGINATION PAYLOAD
                        var paginationFromURL = klevu.dom.helpers.getQueryStringValue("Page");
                        paginationFromURL = Number(paginationFromURL);
                        var limit = window.klevuCurrentScope.element.kObject.getScope().data.request.original.queryRequest[0].settings.limit;
                        limit = Number(limit);
                        if (limit > 0) {
                            var expectedOffset = ((paginationFromURL - 1) * limit) > 0 ? ((paginationFromURL - 1) * limit) : 0;
                            klevu.setObjectPath(data, "localOverrides.query." + activeQueryId + ".settings.offset", expectedOffset);
                            // klevu.search.modules.addParamsToURL.base.backBtnCounter.backBtn = 0;
                        }

                        // SET FILTER PAYLOAD
                        var filtersFromURL = klevu.dom.helpers.getQueryStringValue("Filters");
                        if (filtersFromURL && filtersFromURL.length) {
                            var facets = filtersFromURL.split(";");
                            // loop through all facets to get its values
                            let facetKey = '';
                            let facetValues = [];
                            let facetsArray = [];

                            klevu.each(facets, function (key, facet) {
                                var splitFacet = facet.split(":");
                                if (splitFacet.length) {
                                    facetKey = decodeURIComponent(splitFacet[0]);
                                    facetValues = decodeURIComponent(splitFacet[1]).split(",");
                                    facetsArray.push({ key: facetKey, values: facetValues });
                                }
                            });
                            // set the payload with correct filters:
                            klevu.setObjectPath(data, "localOverrides.query." + activeQueryId + ".filters.applyFilters.filters", facetsArray);
                        } else { // reset filters if Back button pressed, and there's no filters
                            klevu.setObjectPath(data, "localOverrides.query." + activeQueryId + ".filters.applyFilters.filters", []);
                        }
                    }
                },
                build: true
            },
            smoothScrollToProductListingTop: function () {
                let customOffset = 150;
                const selectorsToTriggerScrollToTop = {
                  pagination: '.kuPagination a',
                  // filterOptions: '.klevuFilterOption',
                  // Add more selectors here as needed
                }
                function _smoothScrollToKlevuTop() {
                  setTimeout(function () {
                      var target = document.getElementsByClassName('klevuMeta')[0];
          
                      if (target) {
                          var topPosition = target.getBoundingClientRect().top + window.pageYOffset;
          
                          window.scrollTo({
                              top: topPosition - customOffset,
                              behavior: 'smooth'
                          });
                      }
                  }, 200);
                }
                Object.values(selectorsToTriggerScrollToTop).forEach(selector => {
                  document.querySelectorAll(selector).forEach(el => el.addEventListener('click', _smoothScrollToKlevuTop));
                });
            },
            clearFacetOptions: function (data, scope) {
                klevu.each(klevu.dom.find(".clear-options-button"), function (key, element) {
                    klevu.event.attach(element, "click", function (event) {
                        event.stopPropagation();
                        var target = klevu.dom.helpers.getClosest(this, ".klevuTarget");
                        if (target === null) {
                            return;
                        }
                        var options = klevu.dom.helpers.getClosest(this, ".klevuMeta");
                        if (options === null) {
                            return;
                        }
                        var elScope = target.kElem;
                        elScope.kScope.data = elScope.kObject.resetData(elScope.kElem);
                        elScope.kScope.data.context.keyCode = 0;
                        elScope.kScope.data.context.eventObject = event;
                        elScope.kScope.data.context.event = "keyUp";
                        elScope.kScope.data.context.preventDefault = false;
    
                        var facetName = event.target.dataset.facet ? event.target.dataset.facet : undefined;
    
                        try {
                            var filterArray = Array.from(
                                scope.kScope.data.localOverrides.query
                                    .productList.filters.applyFilters.filters
                            );
    
                            if (filterArray.length < 1) {
                                return;
                            }
                        } catch (error) {
                            console.log(error);
                            return;
                        }
    
                        const newFacets = filterArray.filter(item => item.key !== facetName);
    
                        klevu.setObjectPath(
                            elScope.kScope.data,
                            "localOverrides.query." +
                            options.dataset.section +
                            ".settings.offset",
                            0
                        );
                        klevu.setObjectPath(
                            elScope.kScope.data,
                            "localOverrides.query." +
                            options.dataset.section +
                            ".filters.applyFilters.filters",
                            newFacets
                        );
                        klevu.event.fireChain(
                            elScope.kScope,
                            "chains.events.keyUp",
                            elScope,
                            elScope.kScope.data,
                            event
                        );
                    });
                });
            },
            closeFilterOnOutsideClick: function (data, scope) {
                klevu.event.attach(document.body, "click", function (event) {
                    function hasSomeParentTheClass(element, classname) {
    
                        if (typeof element.className !== 'object' && typeof element.className !== 'undefined' && element.className.split(' ').indexOf(classname) >= 0) return true;
                        return element.parentNode && hasSomeParentTheClass(element.parentNode, classname);
                    }
    
                    if (!hasSomeParentTheClass(event.target, 'kuFilterBox')) {
                        klevu.each(klevu.dom.find(".kuFilterHead"), function (key, facet) {
    
                            //if (event.currentTarget.dataset.label !== facet.dataset.label) {
                            facet.classList.add('kuExpand');
                            facet.classList.remove('kuCollapse');
                            //}
                            facet.nextElementSibling.classList.remove("kuFilterCollapse");
                            facet.nextElementSibling.classList.add("kuFilterShowAll");
                        });
    
                        sessionStorage.removeItem('klv_filter');
    
                    }
                });
            },
            oneFacetIsOpened: function (data, scope) {
                klevu.each(klevu.dom.find(".kuFilterHead"), function (key, value) {
                    klevu.event.attach(value, "click", function (event) {
                        klevu.each(klevu.dom.find(".kuFilterHead"), function (key, facet) {
                            if (event.target.dataset.label !== facet.dataset.label) {
                                facet.classList.add('kuExpand');
                                facet.classList.remove('kuCollapse');
                            }
                            facet.nextElementSibling.classList.remove("kuFilterCollapse");
                            facet.nextElementSibling.classList.add("kuFilterShowAll");
                        });
                    });
                });
            },
            filterSortingMobileToggler: function (data, scope) {
                /** 
                 * TOGGLE FILTERS & SORTING ON MOBILE
                 */
                const documentBody = document.body;
        
                function clickHandler({ target }) {
                    if (target.matches('.ku-filterOpener, .ku-filterOpener *, .filters-close-btn, .filters-close-btn *')) {
                        documentBody.classList.toggle("klevu-filters-opened");
                    }
                    if (target.matches('.kuFilters .kuFilterBox, .kuFilters .kuFilterBox *')) {
                        documentBody.classList.remove('klevu-sorting-opened');
                    }
                }
                if (!documentBody.dataset.klevuMobileFiltersClickListenerAttached) {
                    klevu.event.attach(documentBody, "click", clickHandler);
                    documentBody.dataset.klevuMobileFiltersClickListenerAttached = "true"; // Set the data attribute - Mark the handler as attached
                }
        
                function sortingClickHandler({ target }) {
                    if (target.matches('.kuDropdown.kuDropSortBy, .kuDropdown.kuDropSortBy *')) {
                        documentBody.classList.toggle('klevu-sorting-opened');
                    }
                    if (target.matches('.kuDropOption.kuSort, .kuDropOption.kuSort *, .sorting-close-btn, .sorting-close-btn *')) {
                        documentBody.classList.remove('klevu-sorting-opened');
                    }
                }
                if (!documentBody.dataset.klevuSortingClickListenerAttached) {
                    klevu.event.attach(documentBody, "click", sortingClickHandler);
                    documentBody.dataset.klevuSortingClickListenerAttached = "true"; // Set the data attribute - Mark the handler as attached
                }
            },
            addKlevuBodyClass: function () {
                document.body.classList.add('klevu-page');
            }
        });
    })(klevu);
})

// Apply the facets supplied in the current URL string
klevu.modifyRequest("landing", function (data, scope) {
    // Restore Search Params On Page Load
    klevu.search.modules.addParamsToURL.base.restoreSearchParamsOnPageLoad(data, scope);

    // set the global scope
    window.klevuCurrentScope = scope.kScope;

    // No results limit
    klevu.each(data.request.current.recordQueries, function (key, query) {
        const queryID = klevu.getObjectPath(query, "id");
        if (queryID === 'noResultsFoundPopularProductList') {
          klevu.setObjectPath(query, "settings.limit", 8);
        }
      });
    // No results limit END
});

klevu.afterTemplateRender("landing", function (data, scope) {
    klevu.search.modules.addParamsToURL.base.addURLtoHistory(data, scope);
    klevu.search.modules.filterSortingMobileToggler(data, scope);
    klevu.search.modules.smoothScrollToProductListingTop(data, scope);
    klevu.search.modules.clearFacetOptions(data, scope);
    klevu.search.modules.closeFilterOnOutsideClick(data, scope);
    klevu.search.modules.oneFacetIsOpened(data, scope);
    klevu.search.modules.addKlevuBodyClass();
});


window.onpopstate = function (event) {
    try {
        // passing activeQueryId because it's lost once we reset the data below
        var activeQueryId = klevu.getObjectPath(window.klevuCurrentScope.element.kObject.getScope().data, "context.activeQueryId");
        // code to get ready to reset all the data
        var data = window.klevuCurrentScope.element.kObject.getScope().data;
        var scope = window.klevuCurrentScope.element;
        scope.kScope.data = scope.kObject.resetData(scope.kElem);
        scope.kScope.data.context.keyCode = 0;
        scope.kScope.data.context.eventObject = event;
        scope.kScope.data.context.event = "keyUp";
        scope.kScope.data.context.preventDefault = false;

        // Get payload for Filters & Pagination
        klevu.search.modules.addParamsToURL.base.updatePayloadOnPopState(data, scope, activeQueryId);

        // Fire request, re-render results
        klevu.event.fireChain(scope.kScope, "chains.events.keyUp", scope, scope.kScope.data, event);
    } catch (error) {
        console.log(error)
    }
};
/* ============ LANDING & CATNAV TEMPLATES ============= */
var klevuLandingTemplateResultsCustom = `

<div class="kuResultsListing">
    <div class="productList klevuMeta" data-section="productList">
        <div class="kuResultContent">
            <div class="kuResultWrap <%=(data.query.productList.filters.length == 0 )?'kuBlockFullwidth':''%>">

                <div ku-container data-container-id="ku_landing_main_content_container" data-container-role="content">
                    <section ku-container data-container-id="ku_landing_main_content_left" data-container-position="left" data-container-role="left">
                        <div ku-block data-block-id="ku_landing_left_facets">
                            <%=helper.render('filters',scope,data,"productList") %>
                        </div>


                            <div class="klevu-filters-and-sort">
                                <div class="ku-filterOpener">
                                    <span> Filter </span>
                                </div>
                                <%=helper.render('sortBy',scope,data,"productList") %>
                            </div>


                        <div ku-block data-block-id="ku_landing_left_call_outs"></div>
                        <div ku-block data-block-id="ku_landing_left_banner"></div>
                    </section>
                    <section ku-container data-container-id="ku_landing_main_content_center" data-container-position="center" data-container-role="center">
                        
                        <header ku-block data-block-id="ku_landing_result_header">
                            <%=helper.render('klevuLandingTemplateResultsHeadingTitle',scope,data,"productList") %>
                            <%=helper.render('filtersTop',scope,data,"productList") %>
                            <%= helper.render('kuFilterTagsTemplate',scope,data,"productList") %>
                            <% if(helper.hasResults(data,"productList")) { %>
                                <%=helper.render('limit',scope,data,"productList") %>
                                <%=helper.render('kuTemplateLandingResultsViewSwitch',scope,data,"productList") %>
                            <% } %>
                            <div class="kuClearBoth"></div>
                        </header>

                        <div ku-block data-block-id="ku_landing_result_items">
                            <div class="kuResults">
                                <% if(helper.hasResults(data,"productList")) { %>
                                    <ul>
                                        <% helper.each(data.query.productList.result,function(key,item){ %>
                                            <% if(item.typeOfRecord == "KLEVU_PRODUCT") { %>
                                                <%=helper.render('productBlock',scope,data,item) %>
                                            <% } %>
                                        <% }); %>
                                    </ul>
                                <% } else { %>
                                    <div class="kuNoRecordsFoundLabelTextContainer">
                                        <span class="kuNoRecordsFoundLabelText"><%= helper.translate("No records found for your selection") %></span>
                                    </div>
                                <% } %>
                                <div class="kuClearBoth"></div>
                            </div>
                            <!-- replace pagination -->
                            
                            <%=helper.render('pagination',scope,data,"productList") %>

                        </div>
                        
                        <div ku-block data-block-id="ku_landing_other_items">
                            <%=helper.render('klevuLandingTemplateInfiniteScrollDown',scope,data) %>                               
                        </div>
                        <footer ku-block data-block-id="ku_landing_result_footer"></footer>
                    </section>
                    <section ku-container data-container-id="ku_landing_main_content_right" data-container-position="right" data-container-role="right">
                        <div ku-block data-block-id="ku_landing_right_facets"></div>
                        <div ku-block data-block-id="ku_landing_right_call_outs"></div>
                        <div ku-block data-block-id="ku_landing_right_banner"></div>
                    </section>
                </div>
                
            </div>
        </div>
    </div>

    <% if(data.query.contentList) { %>
        <div class="contentList klevuMeta" data-section="contentList" data-result-view="list">
            <div class="kuResultContent">
                <div class="kuResultWrap <%=(data.query.contentList.filters.length == 0 )?'kuBlockFullwidth':''%>">

                    <div ku-container data-container-id="ku_landing_main_content_container" data-container-role="content">
                        <section ku-container data-container-id="ku_landing_main_content_left" data-container-position="left" data-container-role="left">
                            <div ku-block data-block-id="ku_landing_left_facets">
                                <%=helper.render('filters',scope,data,"contentList") %>
                            </div>


                            <div class="klevu-filters-and-sort">
                                <div class="ku-filterOpener">
                                    <span> Filter </span>
                                </div>
                                <%=helper.render('sortBy',scope,data,"productList") %>
                            </div>

                            
                            <div ku-block data-block-id="ku_landing_left_call_outs"></div>
                            <div ku-block data-block-id="ku_landing_left_banner"></div>
                        </section>
                        <section ku-container data-container-id="ku_landing_main_content_center" data-container-position="center" data-container-role="center">
                            
                            <header ku-block data-block-id="ku_landing_result_header">
                                <%=helper.render('filtersTop',scope,data,"contentList") %>
                                <%= helper.render('kuFilterTagsTemplate',scope,data,"contentList") %>
                                <% if(helper.hasResults(data,"contentList")) { %>
                                    <%=helper.render('limit',scope,data,"contentList") %>
                                <% } %>
                                <div class="kuClearBoth"></div> 
                            </header>

                            <div ku-block data-block-id="ku_landing_result_items">
                                <div class="kuClearBoth"></div>
                                <div class="kuResults">
                                    <% if(helper.hasResults(data,"contentList")) { %>
                                        <ul>
                                            <% helper.each(data.query.contentList.result,function(key,item){ %>
                                                <% if(item.typeOfRecord == "KLEVU_CMS") { %>
                                                    <%=helper.render('contentBlock',scope,data,item) %>
                                                <% }%>
                                            <% }); %>
                                        </ul>
                                    <% } else { %>
                                        <div class="kuNoRecordsFoundLabelTextContainer">
                                            <span class="kuNoRecordsFoundLabelText"><%= helper.translate("No records found for your selection") %></span>
                                        </div>
                                    <% } %>
                                    <div class="kuClearBoth"></div>
                                </div>
                                <%=helper.render('pagination',scope,data,"contentList") %>
                            </div>
                            <div ku-block data-block-id="ku_landing_other_items">
                                <%=helper.render('klevuLandingTemplateInfiniteScrollDown',scope,data) %>
                            </div>
                            <footer ku-block data-block-id="ku_landing_result_footer"></footer>
                        </section>
                        <section ku-container data-container-id="ku_landing_main_content_right" data-container-position="right" data-container-role="right">
                            <div ku-block data-block-id="ku_landing_right_facets"></div>
                            <div ku-block data-block-id="ku_landing_right_call_outs"></div>
                            <div ku-block data-block-id="ku_landing_right_banner"></div>
                        </section>
                    </div>
                    
                </div>
            </div>
        </div>
    <% } %> 

</div>`;

var klevuLandingTemplatePaginationCustom = `
<% if(data.query[dataLocal].result.length > 0 ) { %>
    <%
        var resultsPerPage = data.query[dataLocal].meta.noOfResults;
        var totalResultsFound = data.query[dataLocal].meta.totalResultsFound - 1;
        const lastPageOffset = (Math.floor(totalResultsFound/resultsPerPage)*resultsPerPage);
        const currentOffset = data.query[dataLocal].meta.offset;
        const productListLimit = data.query.productList.meta.noOfResults;
        const currentPage = (Math.ceil(currentOffset/resultsPerPage)+1);
        const customOffsetPrev = currentOffset - productListLimit;
        const customOffsetNext = (currentOffset + (resultsPerPage)) >= lastPageOffset ? lastPageOffset : (currentOffset + (resultsPerPage));
        const customOffsetPrevTotRes = currentPage <= 1 ? 1 : (productListLimit * (currentPage - 1));
        const totalPages = (Math.ceil(totalResultsFound/resultsPerPage));
        const isLastPage = currentPage === totalPages;
        const productListTotal = data.query.productList.meta.totalResultsFound - 1;
        const lastPage = (Math.ceil(productListTotal/productListLimit) - currentPage) >= 1 ? (Math.ceil(productListTotal/productListLimit)) : 0;
        const toProducts = data.query.productList.meta.offset+productListLimit >= productListTotal ? productListTotal : data.query.productList.meta.offset+productListLimit;
        const arrowRightSVG = '<svg width="21" height="20" style="pointer-events: none;" xmlns="http://www.w3.org/2000/svg"><path d="M13.212 5.592a.83.83 0 0 0-1.175 0L8.212 9.417a.83.83 0 0 0 0 1.175l3.825 3.825a.83.83 0 1 0 1.175-1.175L9.978 10l3.234-3.233a.838.838 0 0 0 0-1.175z" fill="#B2B2B2" fill-rule="evenodd"/></svg>'; 
    %>
    
    <div class="kuPagination kuPagination--custom">

        <div class="klevuPaginate-wrapper">

            <% if(currentOffset > 0) { %>
                <a target="_self" href="javascript:void(0)"  class="klevuPaginate klevuPaginate_prev" rel="prev" data-offset="<%= customOffsetPrev %>">
                <svg style="pointer-events: none;" role="presentation" viewBox="0 0 11 18"><path d="M9.5 1.5L1.5 9l8 7.5" stroke-width="2" stroke="currentColor" fill="none" fill-rule="evenodd" stroke-linecap="square"></path></svg>
                </a>
            <% } %>

            <% if (currentPage === 2) { %>
                <a target="_self" href="javascript:void(0)" class="klevuPaginate" data-offset="<%=(currentOffset - resultsPerPage)%>"><%=(Math.ceil(currentOffset/resultsPerPage))%></a>
            <% } %>
            <% if (currentPage === 3) { %>
                <a target="_self" href="javascript:void(0)" class="klevuPaginate" data-offset="<%=(currentOffset - (resultsPerPage * 2))%>"><%=(Math.ceil(currentOffset/resultsPerPage)-1)%></a>
                <a target="_self" href="javascript:void(0)" class="klevuPaginate" data-offset="<%=(currentOffset - resultsPerPage)%>"><%=(Math.ceil(currentOffset/resultsPerPage))%></a>
            <% } %>
            <% if (currentPage >= 4) { %>
                <a target="_self" href="javascript:void(0)" class="klevuPaginate" data-offset="<%=(currentOffset - (resultsPerPage * 3))%>"><%=(Math.ceil(currentOffset/resultsPerPage)-2)%></a>
                <a target="_self" href="javascript:void(0)" class="klevuPaginate" data-offset="<%=(currentOffset - (resultsPerPage * 2))%>"><%=(Math.ceil(currentOffset/resultsPerPage)-1)%></a>
                <a target="_self" href="javascript:void(0)" class="klevuPaginate" data-offset="<%=(currentOffset - resultsPerPage)%>"><%=(Math.ceil(currentOffset/resultsPerPage))%></a>
            <% } %>


            <a href="javascript:void(0);" class="kuCurrent"><%=(Math.ceil(currentOffset/resultsPerPage)+1)%></a>


            <% if(totalResultsFound >= currentOffset + resultsPerPage) { %>
                <a target="_self" href="javascript:void(0)" class="klevuPaginate" data-offset="<%=(currentOffset+resultsPerPage)%>"><%=(Math.ceil(currentOffset/resultsPerPage)+2)%></a>
            <% } %>
            <% if (totalPages - currentPage === 2) { %>
                <a target="_self" href="javascript:void(0)" class="klevuPaginate" data-offset="<%=(currentOffset+(resultsPerPage * 2))%>"><%=(Math.ceil(currentOffset/resultsPerPage)+3)%></a>
            <% } %>
            <% if (totalPages - currentPage >= 3) { %>
                <a target="_self" href="javascript:void(0)" class="klevuPaginate" data-offset="<%=(currentOffset+(resultsPerPage * 2))%>"><%=(Math.ceil(currentOffset/resultsPerPage)+3)%></a>
            <% } %>
            <% if (totalPages - currentPage >= 4) { %>
                <a target="_self" href="javascript:void(0)" class="klevuPaginate" data-offset="<%=(currentOffset+(resultsPerPage * 3))%>"><%=(Math.ceil(currentOffset/resultsPerPage)+4)%></a>
            <% } %>

            <% if(totalResultsFound >= currentOffset + resultsPerPage && totalPages > 3) { %>
                <a target="_self" href="javascript:void(0)" rel="next" class="klevuPaginate klevuPaginate_next" data-offset="<%=customOffsetNext%>">
                    <svg style="pointer-events: none;" role="presentation" viewBox="0 0 11 18"><path d="M1.5 1.5l8 7.5-8 7.5" stroke-width="2" stroke="currentColor" fill="none" fill-rule="evenodd" stroke-linecap="square"></path> </svg>
                </a>
            <% } %>

        </div>
    </div>

<% } %>`;

var klevuLandingTemplateFiltersCustom = `
<% if(data.query[dataLocal].filters.length > 0 ) { %>
    <div class="kuFiltersWrapper">
        <div class="kuFiltersHeader">
            <h4 class="filters-title">Filter by</h4>
            <a class="filters-close-btn">
                <svg class="Icon Icon--close" width="22" height="22" viewBox="0 0 22 22" fill="none" role="presentation" xmlns="http://www.w3.org/2000/svg">
                    <path d="M21 1L1 21M1 1L21 21" stroke="currentColor" stroke-linecap="square" stroke-linejoin="round"></path>
                </svg>
            </a>
        </div>
    <div class="kuFilters" role="navigation" data-position="left" aria-label="Product Filters" tabindex="0">
        <h3 class="kuFiltersTitleHeading"><%=helper.translate("Narrow by")%></h3>
        <% helper.each(data.query[dataLocal].filters,function(key,filter){ %>
            <% filter.isCollapsed = true;%>
            <% if(filter.type == "OPTIONS" && filter.options.length > 0){ %>
                <div class="kuFilterBox klevuFilter <%=(filter.multiselect)?'kuMulticheck':''%>" data-filter="<%=filter.key%>" <% if(filter.multiselect){ %> data-singleselect="false" <% } else { %> data-singleselect="true"<% } %>>
                <% var filter_label = (filter.label.toLowerCase() == "price range") ? "price" : filter.label; %>
                <% var renderButton = false; %>
                <% helper.each(filter.options,function(key,option){ %>
                <% if(option.selected ){
                    renderButton = true;
                } %>
                <% }); %>

                    <div class="kuFilterHead <%=(filter.isCollapsed) ? 'kuExpand' : 'kuCollapse'%>" data-label="<%= filter_label %>">
                        <%=helper.translate(filter_label)%>
                        <% if(renderButton){ %>
                            <button data-facet="<%=filter.key%>" class="clear-options-button"><%=helper.translate("Clear")%></button>
                        <% } %>
                    </div>
                    <div data-optionCount="<%= filter.options.length %>" class="kuFilterNames <%= (filter.options.length <= 5 ) ? 'kuFilterShowAll': '' %> <%=(filter.isCollapsed) ? 'kuFilterCollapse' : ''%>">
                        <ul>
                            <% helper.each(filter.options,function(key,filterOption){ %>
                                <li <% if(filterOption.selected ==true) { %> class="kuSelected"<% } %>>
                                    <a
                                        target="_self" 
                                        href="#" 
                                        title="<%=helper.escapeHTML(filterOption.name)%>" 
                                        class="klevuFilterOption<% if(filterOption.selected ==true) { %> klevuFilterOptionActive<% } %>" 
                                        data-value="<%=helper.escapeHTML(filterOption.value)%>"
                                        data-name="<%=helper.escapeHTML(filterOption.name)%>" 
                                    >
                                        <span class="kuFilterIcon"></span>
                                        <span class="kufacet-text"><%=filterOption.name%></span>
                                        <% if(filterOption.selected ==true) { %>
                                            <span class="kuFilterCancel">X</span>
                                        <% } else { %>
                                            <span class="kuFilterTotal"><%=filterOption.count%></span>
                                        <% } %>
                                    </a>
                                </li>
                                
                            <%  }); %>
                        </ul>
                        <% if(filter.options.length > 5 ) { %>
                            <div class="kuShowOpt" tabindex="-1">
                                <span class="kuFilterDot"></span><span class="kuFilterDot"></span><span class="kuFilterDot"></span>
                            </div>
                        <% } %>
                    </div>
                </div>
            <% } else if(filter.type == "SLIDER")  { %>
                <div class="kuFilterBox klevuFilter" data-filter="<%=filter.key%>">
                    <div class="kuFilterHead <%=(filter.isCollapsed) ? 'kuExpand' : 'kuCollapse'%>">
                        <% var filter_label = (filter.label=="klevu_price") ? "price" : filter.label; %>
                        <%=helper.translate(filter_label)%>
                    </div>
                    <div class="kuFilterNames sliderFilterNames <%=(filter.isCollapsed) ? 'kuFilterCollapse' : ''%>">                           
                        <div class="kuPriceSlider klevuSliderFilter" data-query = "<%=dataLocal%>">
                            <div data-querykey = "<%=dataLocal%>" class="noUi-target noUi-ltr noUi-horizontal noUi-background kuSliderFilter kuPriceRangeSliderFilter<%=dataLocal%>"></div>
                        </div>
                    </div>
                </div>
            <% } else if (filter.type == "RATING")  { %>
                <div class="kuFilterBox klevuFilter <%=(filter.multiselect)?'kuMulticheck':''%>" data-filter="<%=filter.key%>" <% if(filter.multiselect){ %> data-singleselect="false" <% } else { %> data-singleselect="true"<% } %>>
                    <div class="kuFilterHead <%=(filter.isCollapsed) ? 'kuExpand' : 'kuCollapse'%>">
                        <%=helper.translate(filter.label)%>
                    </div>
                    <div data-optionCount="<%= filter.options.length %>" class="kuFilterNames <%= (filter.options.length <= 5 ) ? 'kuFilterShowAll': '' %> <%=(filter.isCollapsed) ? 'kuFilterCollapse' : ''%>">
                        <ul>
                            <% helper.each(filter.options,function(key,filterOption){ %>
                                <li <% if(filterOption.selected ==true) { %> class="kuSelected"<% } %>>
                                    <a
                                        target="_self" 
                                        href="#" 
                                        title="<%=helper.escapeHTML(filterOption.name)%>" 
                                        class="klevuFilterOption<% if(filterOption.selected ==true) { %> klevuFilterOptionActive<% } %>" 
                                        data-value="<%=helper.escapeHTML(filterOption.value)%>"
                                        data-name="<%=helper.escapeHTML(filterOption.name)%>"
                                    >
                                        <span class="kuFilterIcon"></span>
                                        <span class="kufacet-text">
                                            <div class="klevuFacetStars">
                                                <div class="klevuFacetRating" style="width:<%=(20*Number(filterOption.name))%>%;"></div>
                                            </div>
                                        </span>
                                        <% if(filterOption.selected ==true) { %>
                                            <span class="kuFilterCancel">X</span>
                                            <% } else { %>
                                                <span class="kuFilterTotal"><%=filterOption.count%></span>
                                        <% } %>
                                    </a>
                                </li>
                                
                            <%  }); %>
                        </ul>
                    </div>
                </div>
            <% } else { %>
                <!-- Other Facets -->
            <% } %>
        <% }); %>


            <%=helper.render('sortBy',scope,data,"productList") %>


        <!-- <div class="kuFiltersFooter">
            <a target="_self" href="javascript:void(0)" class="kuBtn kuFacetsSlideOut kuMobileFilterCloseBtn" role="button" tabindex="0" area-label=""><%=helper.translate("Close")%></a>
        </div> -->

    </div>
    </div>
<% } %>`;

var klevuLandingTemplateSortByCustom = `
<div class="kuDropdown kuDropSortBy" role="listbox">
    <!-- rename sorting title -->
    <div class="kuDropdownLabel"><%=helper.translate("Sort")%></div>

    <div class="kuDropdownOptions">
        <!--- add header for mobile -->



            <div class="klevu-sorting-header">
                <h4 class="sorting-title">Sort by</h4>
                <a class="sorting-close-btn">
                    <svg class="Icon Icon--close" width="22" height="22" viewBox="0 0 22 22" fill="none" role="presentation" xmlns="http://www.w3.org/2000/svg">
                        <path d="M21 1L1 21M1 1L21 21" stroke="currentColor" stroke-linecap="square" stroke-linejoin="round"></path>
                    </svg>
                </a>
            </div>

        <div class="kuDropOption kuSort<% if(helper.getSortBy(dataLocal) == 'Relevance'){ %> active<% } %>" data-value="RELEVANCE" role="option"><%=helper.translate("Relevance")%></div>
        <div class="kuDropOption kuSort<% if(helper.getSortBy(dataLocal) == 'Price: Low to high'){ %> active<% } %>" data-value="PRICE_ASC" role="option"><%=helper.translate("Price: Low to high")%></div>
        <div class="kuDropOption kuSort<% if(helper.getSortBy(dataLocal) == 'Price: High to low'){ %> active<% } %>" data-value="PRICE_DESC" role="option"><%=helper.translate("Price: High to low")%></div>
    </div>
</div>`;